import { z } from 'zod';

export const GetPartyByDocumentQuerySchema = z.object({
  document: z.string().trim().min(1),
});

export type GetPartyByDocumentQuery = z.infer<typeof GetPartyByDocumentQuerySchema>;
